import { render, staticRenderFns } from "./activation-step.vue?vue&type=template&id=025bf794&scoped=true&"
import script from "./activation-step.vue?vue&type=script&lang=js&"
export * from "./activation-step.vue?vue&type=script&lang=js&"
import style0 from "./activation-step.vue?vue&type=style&index=0&id=025bf794&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bf794",
  null
  
)

export default component.exports